import * as i0 from '@angular/core';
import { EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import * as i1 from '@eui/core';
import { UxPublishErrorFeedbackEvent, UxClearErrorFeedbackEvent } from '@eui/core';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i3 from '@eui/components/legacy/ux-control-feedback';
import { UxControlFeedbackComponentModule } from '@eui/components/legacy/ux-control-feedback';
import * as i4 from '@eui/components/legacy/ux-alert';
import { UxAlertComponentModule } from '@eui/components/legacy/ux-alert';
import * as i5 from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import { coerceBooleanProperty } from '@angular/cdk/coercion';

class UxErrorOutputComponent {
    constructor(uxErrorFeedbackService) {
        this.uxErrorFeedbackService = uxErrorFeedbackService;
        this.errorFeedBacks = [];
        this.errors = new EventEmitter();
        this.e2eAttr = 'ux-error-output';
    }
    get isAlert() { return this._isAlert; }
    set isAlert(value) { this._isAlert = coerceBooleanProperty(value); }
    ngOnInit() {
        this.initShape();
    }
    ngOnChanges(changes) {
        if (changes &&
            changes.uxErrorOutput) {
            this.initShape();
        }
    }
    ngOnDestroy() {
        this.errorSubs.unsubscribe();
    }
    initShape() {
        if (this.uxErrorOutput) {
            this.errorFeedBacks = this.uxErrorOutput.getFeedBacks();
        }
        else if (this.errorManager) {
            this.runErrorSubscription();
        }
        else {
            this.errorManager = this.uxErrorFeedbackService.createGlobalErrorManager();
            this.runErrorSubscription();
        }
    }
    runErrorSubscription() {
        this.errorSubs = this.errorManager.errors().subscribe({
            next: (evt) => {
                if (evt instanceof UxPublishErrorFeedbackEvent && evt.err) {
                    if (this.itemKey) {
                        this.errorFeedBacks = this.errorFeedBacks.concat(evt.err.getFeedBacks(this.itemKey));
                    }
                    else {
                        this.errorFeedBacks = this.errorFeedBacks.concat(evt.err.getFeedBacks());
                    }
                }
                else if (evt instanceof UxClearErrorFeedbackEvent) {
                    this.errorFeedBacks = [];
                }
                // this.errors.emit(this.errorFeedBacks);
            },
        });
    }
    removeAt(index) {
        this.errorFeedBacks.splice(index, 1);
    }
}
/** @nocollapse */ UxErrorOutputComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxErrorOutputComponent, deps: [{ token: i1.UxErrorFeedbackService }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ UxErrorOutputComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.3", type: UxErrorOutputComponent, selector: "ux-error-output", inputs: { errorManager: "errorManager", itemKey: "itemKey", uxErrorOutput: "uxErrorOutput", isAlert: "isAlert", e2eAttr: "e2eAttr" }, outputs: { errors: "errors" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"ux-error-output\" *ngIf=\"errorFeedBacks.length>0 && isAlert\" attr.data-e2e=\"{{ e2eAttr }}\">\n    <div *ngFor=\"let feedBack of errorFeedBacks;let i = index;\">\n        <ux-alert [isCloseable]=\"true\"\n                  styleClass=\"ux-reduced-margin\"\n                  typeClass=\"{{feedBack.severity ? feedBack.severity : 'danger' }}\" (close)=\"removeAt(i)\">\n            {{ (feedBack.msgId | translate)}}\n        </ux-alert>\n    </div>\n</div>\n<div class=\"ux-error-output\" *ngIf=\"errorFeedBacks.length>0 && !isAlert\" attr.data-e2e=\"{{ e2eAttr }}\">\n    <div *ngFor=\"let feedBack of errorFeedBacks;\">\n        <ux-control-feedback typeClass=\"{{feedBack.severity ? feedBack.severity : 'danger' }}\">\n            {{ feedBack.msgId | translate}}\n        </ux-control-feedback>\n    </div>\n</div>\n", dependencies: [{ kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3.UxControlFeedbackComponent, selector: "ux-control-feedback", inputs: ["styleClass", "typeClass", "e2eAttr"] }, { kind: "component", type: i4.UxAlertComponent, selector: "ux-alert", inputs: ["styleClass", "typeClass", "iconClass", "isMuted", "isCloseable", "e2eAttr"], outputs: ["close"] }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxErrorOutputComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ux-error-output', template: "<div class=\"ux-error-output\" *ngIf=\"errorFeedBacks.length>0 && isAlert\" attr.data-e2e=\"{{ e2eAttr }}\">\n    <div *ngFor=\"let feedBack of errorFeedBacks;let i = index;\">\n        <ux-alert [isCloseable]=\"true\"\n                  styleClass=\"ux-reduced-margin\"\n                  typeClass=\"{{feedBack.severity ? feedBack.severity : 'danger' }}\" (close)=\"removeAt(i)\">\n            {{ (feedBack.msgId | translate)}}\n        </ux-alert>\n    </div>\n</div>\n<div class=\"ux-error-output\" *ngIf=\"errorFeedBacks.length>0 && !isAlert\" attr.data-e2e=\"{{ e2eAttr }}\">\n    <div *ngFor=\"let feedBack of errorFeedBacks;\">\n        <ux-control-feedback typeClass=\"{{feedBack.severity ? feedBack.severity : 'danger' }}\">\n            {{ feedBack.msgId | translate}}\n        </ux-control-feedback>\n    </div>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: i1.UxErrorFeedbackService }]; }, propDecorators: { errorManager: [{
                type: Input
            }], itemKey: [{
                type: Input
            }], uxErrorOutput: [{
                type: Input
            }], isAlert: [{
                type: Input
            }], errors: [{
                type: Output
            }], e2eAttr: [{
                type: Input
            }] } });
class UxErrorOutputComponentModule {
}
/** @nocollapse */ UxErrorOutputComponentModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxErrorOutputComponentModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ UxErrorOutputComponentModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.3", ngImport: i0, type: UxErrorOutputComponentModule, declarations: [UxErrorOutputComponent], imports: [CommonModule, UxControlFeedbackComponentModule, UxAlertComponentModule, TranslateModule], exports: [UxErrorOutputComponent] });
/** @nocollapse */ UxErrorOutputComponentModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxErrorOutputComponentModule, imports: [CommonModule, UxControlFeedbackComponentModule, UxAlertComponentModule, TranslateModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxErrorOutputComponentModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, UxControlFeedbackComponentModule, UxAlertComponentModule, TranslateModule],
                    exports: [UxErrorOutputComponent],
                    declarations: [UxErrorOutputComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { UxErrorOutputComponent, UxErrorOutputComponentModule };
